
import {Component, Vue, Prop} from "vue-property-decorator";

@Component({})
export default class MobileListRelayItem extends Vue {

    @Prop({default: {}})
    public item: any;
}
